import { useContext } from 'react';
import './pane-right-tasks-item-template.scss';

export default function TaskItemTemplate(task, isCompact) {

    const isOverdue = (task)=>{
         return task.dateTo && new Date(task.dateTo) < new Date();
    };

    if (!task)
      return <></>

    return (
        <div className="task-item-template-container" >
            <div className="task-item-template-header">
                <div className="task-item-template-header-item-color" style={{ backgroundColor: task.colorHex }} ></div>
                <div className="task-item-template-header-item-order">{task.orderNo ? task.orderNo : ""}</div>
                <div className="task-item-template-header-item" style={{ color: isOverdue(task) ? "red" : "black" }}>{task.datePeriod}</div>
                <div className="task-item-template-header-item">{task.id}</div>
                <div className="task-item-template-header-item">{task.senderAccountName}</div>
            </div>
            <div className="task-item-template-body" dangerouslySetInnerHTML={{ __html: isCompact ? task.textCompact : task.textFormatted }}>

            </div>

            {/*<div className="task-item-template-body">{task.text}*/}

            {/*</div>*/}
        </div>
    );
};





